<template>
   <div class="fc-mega-menu-panel">
      <div v-for="(item, index) in dropdownItems" :key="index" class="fc-mega-menu__group">
         <h3 class="fc-mega-menu__eyebrow">{{ item.header }}</h3>
         <ul class="fc-mega-menu__items fc-mega-menu__items--1col">
            <li v-for="(link, indexNum) in item.items" :key="indexNum">
               <a
                  class="fc-mega-menu__item"
                  itemprop="url"
                  :href="link.link"
                  @click.prevent="goTo(link.link)"
               >
                  <span v-if="link.icon" class="fc-mega-menu__icon">
                     <span v-if="resolveLinkIcon(link)" v-html="resolveLinkIcon(link)"></span>
                     <i v-else :class="link.icon"></i>
                  </span>
                  <span class="fc-mega-menu__label"
                     >{{ link.header
                     }}<span
                        v-if="
                           link.externalProperties &&
                              (link.externalProperties.isNew || link.externalProperties.isnew)
                        "
                        class="fc-mega-menu__badge fc-mega-menu__badge--new"
                        >New</span
                     ><svg
                        v-if="link.header === 'GitHub' || link.header === 'Forum'"
                        class="fc-mega-menu__ext"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="2.4"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        aria-hidden="true"
                     >
                        <path d="M14 4h6v6" />
                        <path d="M20 4l-8.5 8.5" />
                        <path d="M18 14v4a2 2 0 01-2 2H6a2 2 0 01-2-2V8a2 2 0 012-2h4" /></svg
                  ></span>
               </a>
            </li>
         </ul>
      </div>

      <!-- Customer quote / case-study callout - Resources menu only.
           TODO(content): no Contentful field for this yet - hardcoded here,
           same as the "FusionCharts Suite" eyebrow in SideBySide.vue.
           Quote/attribution unverified - confirm wording, name and company
           before this ships. -->
      <div v-if="itemName === 'Resources'" class="fc-mega-menu__quote">
         <figure class="fc-mega-menu__quote-rail">
            <span class="fc-mega-menu__quote-mark" aria-hidden="true">&rdquo;</span>
            <blockquote class="fc-mega-menu__quote-text">
               There are very few software tools or products I have worked with over the years which
               have been as powerful and easy to use as FusionCharts.
            </blockquote>
            <span class="fc-mega-menu__quote-mark fc-mega-menu__quote-mark--end" aria-hidden="true"
               >&rdquo;</span
            >
            <figcaption class="fc-mega-menu__quote-author">Mike McColl, FooTelePros</figcaption>
         </figure>
         <a
            class="fc-mega-menu__quote-cta"
            itemprop="url"
            href="/customers"
            @click.prevent="goTo('/customers')"
            >Read the story &rarr;</a
         >
      </div>
   </div>
</template>

<script>
import { resolveLinkIcon } from '../../util/navIcons';

export default {
   name: 'SimpleDropdown',
   props: {
      dropdownItems: {
         type: Array,
         default: () => [],
      },
      itemName: {
         type: String,
         default: '',
      },
   },
   methods: {
      resolveLinkIcon,
      goTo(url) {
         const reload = this.$reloadType(url);
         if (!reload) {
            this.$router.push(url).catch(() => {});
         } else {
            this.$openReload(url);
         }
      },
   },
};
</script>
